// @file Styles for surface title
import { BreakPoints, useWindowSizeStore } from '@@/pinia/window_size'
import { storeToRefs } from 'pinia'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

export const useSurfaceTitleStyles = (): { lineClampClass: ComputedRef<string> } => {
  const { windowHeight } = storeToRefs(useWindowSizeStore())

  const lineClampClass = computed(() => {
    if (windowHeight.value < BreakPoints.TabletPortrait) {
      return 'line-clamp-1'
    } else if (windowHeight.value < BreakPoints.TabletLandscape) {
      return 'line-clamp-3'
    } else if (windowHeight.value < BreakPoints.Desktop) {
      return 'line-clamp-6'
    } else if (windowHeight.value < BreakPoints.DesktopBig) {
      return 'line-clamp-[8]'
    } else if (windowHeight.value < BreakPoints.Desktop2XL) {
      return 'line-clamp-[10]'
    } else {
      return 'line-clamp-[12]'
    }
  })

  return {
    lineClampClass,
  }
}
